import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';

// Properties
const properties = require('../../properties.json');

const STATUS_META = {
    NONE: { severity: 'secondary', label: 'لم يتم الإضافة' },
    PENDING: { severity: 'warning', label: 'بإنتظار الربط' },
    VERIFIED: { severity: 'success', label: 'تم التفعيل' },
    FAILED: { severity: 'danger', label: 'فشل الربط' },
};

class Domain extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
        this.pollTimer = null;
    }

    state = {
        domainInput: '',
        customDomain: null,
        customDomainStatus: 'NONE',
        saving: false,
        loading: true,
    }

    componentDidMount() {
        document.title = properties.site_name + " | الدومين الخاص";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        this.loadMe();
    }

    componentWillUnmount() {
        clearTimeout(this.pollTimer);
    }

    loadMe = () => {
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    customDomain: me.customDomain,
                    customDomainStatus: me.customDomainStatus || 'NONE',
                    domainInput: me.customDomain || '',
                    loading: false,
                });
                // Keep checking while the DNS/certificate provisioning script hasn't caught up yet.
                if (me.customDomainStatus === 'PENDING') {
                    this.pollTimer = setTimeout(this.loadMe, 10000);
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    saveDomain = () => {
        const domain = (this.state.domainInput || '').trim().toLowerCase();
        if (!domain) return;
        this.setState({ saving: true });
        apiFetch("/teachers/me/custom-domain", { method: "PUT", body: { domain } })
            .then(me => {
                this.setState({
                    customDomain: me.customDomain,
                    customDomainStatus: me.customDomainStatus,
                    saving: false,
                });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'جاري التحقق من الدومين، تابع الحالة تحت' });
                clearTimeout(this.pollTimer);
                this.pollTimer = setTimeout(this.loadMe, 10000);
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    removeDomain = () => {
        var con = window.confirm("هل أنت متأكد من أنك تريد إلغاء ربط الدومين؟");
        if (!con) return;
        apiFetch("/teachers/me/custom-domain", { method: "DELETE" })
            .then(me => {
                clearTimeout(this.pollTimer);
                this.setState({ customDomain: me.customDomain, customDomainStatus: me.customDomainStatus, domainInput: '' });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم إلغاء ربط الدومين' });
            })
            .catch(error => {
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { domainInput, customDomain, customDomainStatus, saving, loading } = this.state;
        const statusMeta = STATUS_META[customDomainStatus] || STATUS_META.NONE;
        const serverIp = properties.manasa_server_ip || 'SERVER_IP';

        return (
            <>
                <Header pageName="الدومين الخاص" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card title="اربط دومينك الخاص">
                                {!loading &&
                                    <div className="p-col-12 p-md-8 p-m-3">
                                        <p>
                                            اكتب دومينك بدون http:// أو www، هيبقى طلابك بيدخلوا على{' '}
                                            <b>الدومين نفسه</b>، ولوحة تحكمك هتبقى على{' '}
                                            <b>admin.الدومين</b>.
                                        </p>
                                        <div className="p-inputgroup p-mb-3">
                                            <InputText
                                                value={domainInput}
                                                placeholder="example.com"
                                                onChange={(e) => this.setState({ domainInput: e.target.value })}
                                            />
                                            <Button label={saving ? "جاري الحفظ..." : "حفظ"} disabled={saving || !domainInput} onClick={this.saveDomain} />
                                        </div>

                                        {customDomain &&
                                            <div className="p-mt-4">
                                                <p>
                                                    الحالة الحالية لـ <b>{customDomain}</b>:{' '}
                                                    <Tag severity={statusMeta.severity} value={statusMeta.label} />
                                                </p>
                                                {customDomainStatus === 'PENDING' &&
                                                    <div className="p-mt-2">
                                                        <p>لتفعيل الدومين، اضبط إعدادات DNS عند مزود الدومين بتاعك كالتالي:</p>
                                                        <ul>
                                                            <li>A record لـ <code>{customDomain}</code> يشاور على <code>{serverIp}</code></li>
                                                            <li>A record لـ <code>admin.{customDomain}</code> يشاور على <code>{serverIp}</code></li>
                                                        </ul>
                                                        <p>بمجرد ما الـ DNS يتظبط هيتفعل تلقائيًا خلال دقائق.</p>
                                                    </div>
                                                }
                                                {customDomainStatus === 'FAILED' &&
                                                    <p>تعذر تفعيل الدومين -- تأكد إن الـ DNS مضبوط صح وجرب تحفظ تاني.</p>
                                                }
                                                <Button label="إلغاء ربط الدومين" className="p-button-danger p-button-text p-mt-2" onClick={this.removeDomain} />
                                            </div>
                                        }
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Domain;
